import React from "react";
import { Helmet } from "react-helmet-async";
const NewReportsPage = () => {
  return (
    <>
      <Helmet title="Reports" />
    </>
  );
};
export default NewReportsPage;
